export default __webpack_public_path__ + "static/cheers-a0bf8adf6cdee59b02aec07fcd93801e.jpg";